import { Router } from '@vaadin/router';

export function navigate(path: string) {
  if (location.pathname === path) {
    location.reload();
    return;
  }

  window.dispatchEvent(new CustomEvent('mbw:navigate-away', { detail: { path } }));
  Router.go(path);
}
